import api from './api';

export interface OutboundWorkflow {
  id: string;
  code: string;
  name: string;
  description: string | null;
  is_active: boolean;
}

export interface OutboundStageExit {
  disposition: string;
  next_stage_code: string | null;
  next_status: string;
}

export interface OutboundStage {
  id: string;
  workflow_id: string;
  code: string;
  name: string;
  sort_order: number;
  kind: string;
  channel: string;
  delay_after_complete_days: number | null;
  script_text: string | null;
  script_version: string | null;
  ai_draft_from_script: boolean;
  default_revisit_days: number | null;
  exits?: OutboundStageExit[];
}

export interface TodayRow {
  enrollment_id: string;
  contact_id: string;
  first_name: string;
  last_name: string;
  email: string | null;
  title: string | null;
  company_name: string | null;
  linkedin_url: string | null;
  stage_code: string;
  stage_name: string;
  stage_kind: string;
  channel: string;
  script_text: string | null;
  status: string;
  trigger_text: string | null;
  next_due_at: string | null;
  revisit_at: string | null;
  bucket: 'overdue' | 'due_today' | 'nurture_review';
}

export const outboundWorkflowService = {
  async listWorkflows(): Promise<OutboundWorkflow[]> {
    const r = await api.get('/crm/outbound/workflows');
    return r.data?.data || [];
  },
  async listStages(workflowId: string): Promise<OutboundStage[]> {
    const r = await api.get(`/crm/outbound/workflows/${workflowId}/stages`);
    return r.data?.data || [];
  },
  async updateStage(stageId: string, patch: Partial<OutboundStage>): Promise<OutboundStage> {
    const r = await api.patch(`/crm/outbound/stages/${stageId}`, patch);
    return r.data?.data;
  },
  async today(): Promise<TodayRow[]> {
    const r = await api.get('/crm/outbound/today');
    return r.data?.data || [];
  },
  async importCsv(csv: string, workflowId?: string): Promise<{
    created: number;
    updated: number;
    enrolled: number;
    skipped: Array<{ line: number; reason: string }>;
  }> {
    const r = await api.post('/crm/outbound/import', { csv, workflow_id: workflowId });
    return r.data?.data;
  },
  async enroll(body: {
    contact_id: string;
    workflow_id?: string;
    stage_code?: string;
    trigger_text?: string;
  }): Promise<{ enrollmentId: string; stageCode: string; status: string }> {
    const r = await api.post('/crm/outbound/enroll', body);
    return r.data?.data;
  },
  async complete(enrollmentId: string, disposition: string): Promise<void> {
    await api.post(`/crm/outbound/enrollments/${enrollmentId}/complete`, { disposition });
  },
};
